var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenterArrowsMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 369,
    height: 323,
    viewBox: "0 0 369 323",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 265.728,
    y: 191.272,
    width: 1.67768,
    height: 2.15565,
    transform: "rotate(-90 265.728 191.272)",
    stroke: "#D94F56",
    strokeWidth: 1.67768
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 265.257,
    y: 255.974,
    width: 1.67768,
    height: 2.15565,
    transform: "rotate(-90 265.257 255.974)",
    stroke: "#D94F56",
    strokeWidth: 1.67768
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 267.171,
    y: 299.647,
    width: 1.67768,
    height: 2.15565,
    transform: "rotate(-90 267.171 299.647)",
    stroke: "#D94F56",
    strokeWidth: 1.67768
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 265.255,
    y: 233.994,
    width: 1.67768,
    height: 2.15565,
    transform: "rotate(-90 265.255 233.994)",
    stroke: "#D94F56",
    strokeWidth: 1.67768
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.83884,
    y: -0.83884,
    width: 1.67768,
    height: 2.15565,
    transform: "matrix(0 -1 -1 0 103.324 320.809)",
    stroke: "#4E5055",
    strokeWidth: 1.67768
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.83884,
    y: -0.83884,
    width: 1.67768,
    height: 2.15565,
    transform: "matrix(0 -1 -1 0 101.916 277.358)",
    stroke: "#D7544F",
    strokeWidth: 1.67768
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M246.17 190.399L266.295 190.399",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M229.844 255.135L265.781 255.135",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M231.832 298.809L267.77 298.809",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M245.729 233.395L265.854 233.395",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M109.793 320.809H103.564",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M108.385 277.358H103.593",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.428 190.432L284.98 190.432C292.919 190.432 299.355 183.996 299.355 176.057V14.7837C299.355 6.84461 305.79 0.408691 313.73 0.408691H368.355",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.666 255.135L284.979 255.135C292.918 255.135 299.354 248.699 299.354 240.76V155.714",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.916 298.809L284.979 298.808C292.918 298.808 299.354 292.373 299.354 284.433V155.809",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.666 233.155L284.979 233.155C292.918 233.155 299.354 226.719 299.354 218.78V155.714",
    stroke: "#D94F56",
    strokeWidth: 0.479167
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.916 320.809L84.2909 320.808C76.3519 320.808 69.916 314.373 69.916 306.433V15.1836C69.916 7.24449 76.3519 0.808594 84.291 0.808594H84.7958",
    stroke: "#4E5055",
    strokeWidth: 0.479167
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.52 277.358L74.4951 277.358C66.556 277.358 60.1201 270.922 60.1201 262.983V15.2632C60.1201 7.32411 53.6842 0.888184 45.7451 0.888184H0.352867",
    stroke: "#D7544F",
    strokeWidth: 0.479167
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterArrowsMd);
export default __webpack_public_path__ + "static/media/center-arrows-md.afbb49fdffeeb1cc7c2da3b4ffd7bbf8.svg";
export { ForwardRef as ReactComponent };